import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingTransparentBackgroundConfig } from '@/data/landingConfig/landingTransparentBackgroundConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_TransparentBackground } from './schemaObject';

interface Props {}
const TransparentBackground: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_TransparentBackground} />
			<LandingTemplate
				data={landingTransparentBackgroundConfig}
				funnelLinkService={GenerateLandingLinkService.funnelRemoveBGV3()}
			/>
		</>
	);
};

export default TransparentBackground;
